import React, { useState } from 'react';

const defaultValue = {
  clientes: [],
  clienteAtual: {},
  selecao: [],
  tipoSelecao: 'NENHUM',
  filtroAvancado: {},
  loading: false,
  totalElements: 0,
  modal: '',
  search: '',
  page: 0,
  size: 15,
  sort: 'pessoa.nome,ASC',
  arquivo: '',
};

export const ClienteContext = React.createContext({});

export const ClienteProvider = (props) => {
  return (
    <ClienteContext.Provider
      value={{
        clientes: useState(defaultValue.clientes),
        clienteAtual: useState(defaultValue.clienteAtual),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        modal: useState(defaultValue.modal),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        arquivo: useState(defaultValue.arquivo),
      }}
    >
      {props.children}
    </ClienteContext.Provider>
  );
};

export const ClienteConsumer = ClienteContext.Consumer;
